import { gql } from "@apollo/client";

export const GET_PARTY_AND_CADIDATE_NUMBER = gql`
  query GetPartyAndCandidateNumber {
    getPartyAndCandidateNumber {
      logo
      partyName
      totalCandidate
      totalFullRight
      totalBackup
      totalBackupFemale
      totalCandidateFemale
      totalFullRightFemale
      numbering
      _id
    }
  }
`;
